@for (paragraph of body; track paragraph) {
  <p class="text-block">
    {{paragraph}}
  </p>
}
